import Stack from '@mui/material/Stack';
import Avatar from 'mantis/components/@extended/Avatar';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';

const UserBadge = (props) => {
	const { name, description, imgSrc } = props;

	return (
		<Stack direction="row" spacing={1.25} alignItems="center">
			<Avatar alt="profile user" src={imgSrc} sx={{ width: 36, height: 36 }} />
			<Stack>
				<Typography>{name}</Typography>
				<Typography variant="caption" color="text.secondary">
					{description}
				</Typography>
			</Stack>
		</Stack>
	);
};

UserBadge.propTypes = {
	imgSrc: PropTypes.string,
	name: PropTypes.string,
	description: PropTypes.string,
};

export default UserBadge;
